import { Record } from 'immutable';

import DriveTrainModel from 'commons-vehicle/ModelYear/models/DriveTrainModel.js';
import EngineModel from 'commons-vehicle/ModelYear/models/EngineModel.js';
import TransmissionModel from 'commons-vehicle/ModelYear/models/TransmissionModel.js';

const DrivePowerTrainRecord = Record({
    trimsBitField: 0,
    trimsBitFields: [],
    selectionCode: '',
    enabled: true,
    visible: true,
    selected: false,
    userSelected: false,
    rank: 0,
    driveTrain: new DriveTrainModel(),
    engine: new EngineModel(),
    transmission: new TransmissionModel(),
    configurationIds: {},
    bestOptionsPackageCode: '',
});

class DrivePowerTrain extends DrivePowerTrainRecord {
    getSelectionCode() {
        return this.get('selectionCode');
    }
}

export default DrivePowerTrain;
